import styled from '@emotion/styled';
import {TextDefault} from '../../shared/styles';

export const ArticleDetailsPageWrapper = styled.div<{gap: string}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({gap}) => gap};
  padding: ${({theme}) => theme.padding.desktop.lg};

  // Mobile
  @media screen and (max-width: ${({theme}) => theme.screenBreakpoint.md.px}) {
    padding: ${({theme}) => theme.padding.desktop.md};
  }
`;

export const ArticleVideo = styled.iframe`
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: ${({theme}) => theme.border.radius.md};
  background-color: ${({theme}) => theme.color.neutral.grey_100};
  backdrop-filter: blur(2px);
  border: none;
`;

export const ArticleContent = styled.div`
  align-self: flex-start;
  color: ${({theme}) => theme.color.neutral.grey_900};

  table {
    max-width: 100%;
    border-collapse: collapse;
    margin-top: ${({theme}) => theme.margin.desktop.lg};
    margin-bottom: ${({theme}) => theme.margin.desktop.lg};
  }

  table th,
  table td {
    padding: ${({theme}) => theme.padding.desktop.sm};
    border: 1px solid ${({theme}) => theme.color.neutral.grey_300};
  }

  table th {
    font-weight: bold;
    text-align: center;
  }

  table td {
    font-weight: normal;
    text-align: center;
  }

  table td:first-of-type {
    font-weight: bold;
    text-align: left;
  }

  > :last-child {
     margin-bottom: 0;
   }
`;

export const ArticleParagraph = styled(TextDefault)`
  margin-bottom: ${({theme}) => theme.margin.desktop.lg};
`;
